import type { Router } from "vue-router";
import { usePageMetaStore } from "@/store/pageMeta.store";
import { useAuthenticationStore } from "@/store/authentication.store";

type NavigationDeps = {
  router: Router;
};

type OrganisationDetails = {
  id: string;
  name: string;
};

export const navigateToMspOrganisation = async (
  { router }: NavigationDeps,
  organisation: OrganisationDetails,
) => {
  const orgId = organisation.id;
  if (!orgId) return;

  const authStore = useAuthenticationStore();
  try {
    await authStore.setMspUser({
      uuid: orgId,
      name: organisation.name,
    });
    await authStore.setCustomer(null);
  } catch {
    // handled centrally via axios interceptors
  }

  const pageMetaStore = usePageMetaStore();
  pageMetaStore.setMSP(organisation.name || "");
  pageMetaStore.setPageTitle({
    title: organisation.name || "",
  });

  try {
    await router.push({ name: "msp-dashboard", params: { orgUuid: orgId } });
  } catch {
    // ignore duplicate navigation
  }
};
